import { CompactFooter } from "./Footers";

export default CompactFooter;
